let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("b5XP1")).then(() => parcelRequire('8XBJD'));